export default function MuslimFriendly() {
  const features = [
    {
      icon: 'ri-mosque-line',
      title: 'Ritual Trips',
      description: 'Makkah, Madinah, and other spiritual centres with accommodations near holy sites'
    },
    {
      icon: 'ri-ancient-gate-line',
      title: 'Cultural Heritage Stays',
      description: 'Experience authentic Middle Eastern culture in traditional settings'
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Halal-Friendly Holidays',
      description: 'Guaranteed halal dining options and prayer facilities at all properties'
    },
    {
      icon: 'ri-parent-line',
      title: 'Family Privacy',
      description: 'Accommodations designed for family comfort, privacy, and high standards'
    }
  ];

  return (
    <section id="family-travel" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-[#C9A961]/10 rounded-full mb-4">
            <span className="text-[#C9A961] text-sm font-semibold">Muslim-Friendly Travel</span>
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-[#1A1F2E] mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Family-Oriented &<br />Culturally Aligned
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Our platform highlights Muslim family-friendly destinations, making Alwaz Travel London a trusted choice for travellers seeking culturally aligned experiences across the Middle East
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {features.map((feature, index) => (
            <div key={index} className="text-center group">
              <div className="w-20 h-20 bg-[#C9A961]/10 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-[#C9A961] transition-all duration-300">
                <i className={`${feature.icon} text-4xl text-[#C9A961] group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A1F2E] mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#1A1F2E] to-[#2A3F4E] rounded-3xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Plan Your Spiritual Journey
          </h3>
          <p className="text-lg text-white/80 mb-8 max-w-2xl mx-auto">
            Whether you're planning Umrah, Hajj, or a cultural exploration, we ensure every detail aligns with your values and expectations
          </p>
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="px-8 py-4 bg-[#C9A961] text-white rounded-lg text-base font-semibold hover:bg-[#B89851] transition-all whitespace-nowrap cursor-pointer"
          >
            Speak with an Advisor
          </button>
        </div>
      </div>
    </section>
  );
}
